export default __webpack_public_path__ + "static/media/kayak.23ba5479.svg";